/* ============================================================
   GEHNA FOR YOU — PDP REFRESH JS
   Repaints the gehna-cro-injected trust badges, viewer line and
   WhatsApp button label into the clean "simple & attractive"
   look. Idempotent; observes briefly for late injections.
   ============================================================ */
(function () {
  'use strict';

  var ICON = {
    ship: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v8H3z"/><path d="M14 10h3.5L21 13v2h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="10.5" width="14" height="9.5" rx="2"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/></svg>',
    gem: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M6 3h12l3 6-9 12L3 9z"/><path d="M3 9h18M9 3 12 9l3-6M12 9v12"/></svg>',
    support: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 13a8 8 0 0 1 16 0"/><rect x="3" y="13" width="4" height="7" rx="1.5"/><rect x="17" y="13" width="4" height="7" rx="1.5"/></svg>'
  };

  function badge(icon, title) {
    return '<div class="gehna-trust-badge">' +
      '<div class="gehna-trust-badge-icon">' + icon + '</div>' +
      '<div class="gehna-trust-badge-title">' + title + '</div>' +
      '</div>';
  }

  function patch() {
    /* Trust badges → Free Shipping / Safe Checkout / Premium Quality / Customer Support */
    var tb = document.querySelector('.gehna-trust-badges');
    if (tb && tb.dataset.gfyPatched !== '1') {
      tb.dataset.gfyPatched = '1';
      tb.innerHTML =
        badge(ICON.ship, 'Free Shipping') +
        badge(ICON.lock, 'Safe Checkout') +
        badge(ICON.gem, 'Premium Quality') +
        badge(ICON.support, 'Customer Support');
    }

    /* WhatsApp button label → "Order on WhatsApp" (keep the icon) */
    var wa = document.querySelector('.gehna-wa-btn');
    if (wa && wa.dataset.gfyPatched !== '1') {
      wa.dataset.gfyPatched = '1';
      var svg = wa.querySelector('svg');
      wa.innerHTML = (svg ? svg.outerHTML : '') + ' Order on WhatsApp';
    }

    /* Viewer line → "N people are currently viewing this piece"
       Rebuild around the live count span (#ub-vc) so gehna-cro's
       interval keeps updating it. */
    var vc = document.getElementById('ub-vc');
    if (vc) {
      var row = vc.closest('.ub-viewers') || vc.parentNode;
      if (row && row.dataset.gfyPatched !== '1') {
        row.dataset.gfyPatched = '1';
        var n = vc.textContent || '';
        row.innerHTML = '<span class="ub-dot"></span><span id="ub-vc">' + n + '</span> people are currently viewing this piece';
      }
    }
  }

  function boot() {
    patch();
    var host = document.querySelector('.product__info-container') || document.body;
    var obs = new MutationObserver(function () { patch(); });
    try { obs.observe(host, { childList: true, subtree: true }); } catch (e) {}
    /* gehna-cro injects on DOMContentLoaded; stop observing once settled */
    setTimeout(function () { patch(); obs.disconnect(); }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
